// NodeHiddenFileInputs.jsx

import React from 'react';

/**
 * NodeHiddenFileInputs
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeHiddenFileInputs = React.memo(({
  photoInputRef,
  videoInputRef,
  documentInputRef,
  filesInputRef,
  onPhotoSelect,
  onVideoSelect,
  onDocumentSelect,
  onFilesSelect,
}) => {

  // ----- RENDER ----- //

  return (
    <>
      <input
        style={{
          display: 'none',
        }}
        ref={photoInputRef}
        type="file"
        multiple
        accept="image/*"
        onChange={onPhotoSelect}
      />
      <input
        style={{
          display: 'none',
        }}
        ref={videoInputRef}
        type="file"
        multiple
        accept="video/*"
        onChange={onVideoSelect}
      />
      <input
        style={{
          display: 'none',
        }}
        ref={documentInputRef}
        type="file"
        multiple
        accept="application/pdf,application/x-google-chrome-pdf,.pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.doc,.docx,application/msword,text/plain,.txt,application/rtf,.rtf,application/vnd.oasis.opendocument.text,.odt,application/zip,application/x-zip-compressed"
        onChange={onDocumentSelect}
      />
      <input
        style={{
          display: 'none',
        }}
        ref={filesInputRef}
        type="file"
        multiple
        accept="image/*,video/*,application/*,text/*,.pdf"
        onChange={onFilesSelect}
      />
    </>
  );
});

// Dev Tools
NodeHiddenFileInputs.displayName = 'NodeHiddenFileInputs';

export default NodeHiddenFileInputs;
